import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { ConfigProvider } from "antd";
import { BrowserRouter } from "react-router";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./provider/AuthProvider.tsx";
const THEME = {
  token: {
    colorPrimary: "#489BA8",
    colorTextBase: "#191818",
    colorBorder: "#E5E7EB",
    fontFamily: "Poppins, sans-serif",
  },
  components: {
    Button: {
      paddingInline: 18,
      fontWeight: 600,
    },
    Typography: {
      titleMarginBottom: 0,
    },
    Input: {
      colorBorder: "#2D3648",
      borderRadius: 4,
      colorTextPlaceholder: "rgba(29, 27, 32, 0.75)",
    },
    Select: {
      colorBorder: "#2D3648",
    },
    DatePicker: {
      colorBorder: "#2D3648",
      borderRadius: 4,
      colorTextPlaceholder: "rgba(29, 27, 32, 0.75)",
    },
    Table: {
      headerBg: "#FFF",
      fontWeightStrong: 700,
      borderRadius: 6,
      borderColor: "rgba(0, 0, 0, 0.15)",
      boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.15)",
    },
    Tabs: {
      colorTextBase: "#6B7280",
      fontSize: 16,
      horizontalMargin: "0px 0px 15px 0px",
    },
  },
};

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <AuthProvider>
      <ConfigProvider theme={THEME}>
        <App />
      </ConfigProvider>
    </AuthProvider>
    <ToastContainer className="z-50"/>
  </BrowserRouter>
);
